<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
                <!--<div class="common-header-block">支付渠道：
                    <el-cascader
                            v-model="channelCodeAndPaymentWay"
                            :options="channelCodeAndPaymentWayOptions"/>
                </div>-->
                <div class="common-header-block">
                    <el-input v-model="userRandomId" placeholder="请输入用户ID">
                        <template slot="prepend">用户ID</template>
                    </el-input>
                </div>
                <!--        <div class="common-header-block">支付渠道：
                            <el-select v-model="channelCodeAndPaymentWay">
                                <el-option
                                        v-for="item of channelCodeAndPaymentWayOptions"
                                        :key="item.label"
                                        :value="item.value"
                                        :label="item.label"/>
                            </el-select>
                        </div>-->
                <div class="common-header-block">客户端渠道：
                    <el-select class="common-el-select-small" v-model="appType">
                        <el-option
                                v-for="item of appTypeOptions"
                                :key="item.label"
                                :value="item.value"
                                :label="item.label"/>
                    </el-select>
                </div>
                <div class="common-header-block">状态：
                    <el-select class="common-el-select-small" v-model="status">
                        <el-option
                                v-for="item of statusOptions"
                                :key="item.label"
                                :value="item.value"
                                :label="item.label"/>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-date-picker
                            v-model="date"
                            type="datetimerange"
                            format="yyyy-MM-dd HH:mm"
                            value-format="yyyy-MM-dd HH:mm"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"/>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                    <el-button type="success" @click="exportFunc">导出</el-button>
                </div>
            </div>
        </div>
        <strong v-if="permissions.osm_all_field" class="common-text-item" v-text="`总充值：${playerRecharge.totalOrderPrice}`"></strong>
        <div class="common-table">
            <el-table
                    row-key="orderNo"
                    v-loading="loading"
                    :data="playerRecharge.beanList"
                    height="100%">
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="操作" align="center" width="150">
                    <template slot-scope="scope">
                        <el-button
                                size="mini"
                                type="primary"
                                @click="updateStatus(scope.row)">手工处理
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="回调状态" align="center">
                    <template slot-scope="scope">{{scope.row.callbackStatus | callbackStatusName}}</template>
                </el-table-column>
                <el-table-column label="状态" min-width="120" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.manualHandlingFlag === 1">手工-支付成功</template>
                        <template v-else>
                            {{scope.row.status | statusName}}
                        </template>
                    </template>
                </el-table-column>
                <el-table-column label="用户ID" width="120" align="center" prop="userRandomId"/>
                <el-table-column label="用户昵称" width="120" align="center" prop="userNickname"/>
                <el-table-column label="外部订单号" min-width="120" align="center" prop="orderNo"/>
                <el-table-column label="内部订单号" min-width="180" align="center" prop="thirdPartyOrderNo"/>
                <el-table-column label="支付金额" align="center" prop="amount"/>
                <el-table-column label="客户端渠道" align="center" width="150">
                    <template slot-scope="scope">{{scope.row.appType | appTypeName}}</template>
                </el-table-column>
                <el-table-column label="支付渠道" width="150" align="center">
                    <template slot-scope="scope">{{scope.row.channelCode |
                        channelCodeAndPaymentWay(scope.row.paymentWay)}}
                    </template>
                </el-table-column>
                <el-table-column label="创建时间" width="150" align="center" prop="createdTime"/>
                <el-table-column label="支付时间" width="150" align="center" prop="paymentTime"/>
                <el-table-column label="银行卡号" width="180" align="center" prop="bankAccount"/>
                <el-table-column label="银行名称" align="center" prop="bankName"/>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="playerRecharge.total"
                :current-page="currentPage"
                @current-change="getList($event)"/>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import {rechargeOrderMixin} from 'mixins'

    export default {
        mixins: [rechargeOrderMixin],
        data() {
            return {
                loading: false,
                appTypeOptions: [
                    {label: '全部', value: ''},
                    {label: 'Android', value: 1},
                    {label: 'iOS', value: 2},
                ],
                appType: '',// 客户端类型
                statusOptions: [
                    {label: '全部', value: ''},
                    {label: '待支付', value: 1},
                    {label: '支付成功', value: 2},
                    {label: '支付失败', value: 3},
                ],
                status: '',// 状态
                date: null,
                currentPage: 1,
                userRandomId: '',
                channelCode: '',// 支付渠道
                paymentWay: '',// 支付方式
                channelCodeAndPaymentWay: '',
                channelCodeAndPaymentWayOptions: [
                    {
                        label: '全部',
                        value: ''
                    },
                    {
                        label: 'Upay - 银行卡',
                        value: 'Upay,1',
                    },
                    {
                        label: 'Upay - 支付宝',
                        value: 'Upay,2',
                    },
                ],
                playerRecharge: {// 玩家平台充值订单
                    beanList: [],
                    total: 0,
                    totalOrderPrice: 0// 总充值
                }
            }
        },
        computed:{
            ...mapState('login',['permissions'])
        },
        filters: {
            channelCodeAndPaymentWay(channelCode, paymentWay) {
                let name = '';
                switch (channelCode) {
                    case 'Upay':
                        name = 'Upay' + paymentWayName(paymentWay);
                        break;
                    default:
                        break;
                }

                function paymentWayName(type) {
                    let arr = [' - 银行卡', ' - 支付宝'];
                    return arr[type - 1];
                }

                return name;
            },
            statusName(type) {
                if (type === 1) {
                    return '待支付'
                } else if (type === 2) {
                    return '支付成功'
                } else if (type === 3) {
                    return '支付失败 '
                }
            }
        },
        watch: {
            channelCodeAndPaymentWay(newVal) {
                let arr = newVal.split(',');
                this.channelCode = arr[0];
                if (this.channelCodeAndPaymentWay.length > 1) {
                    this.paymentWay = arr[1]
                } else {
                    this.paymentWay = ''
                }
            }
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('rechargeOrder', ['playerRechargeList', 'rechargeOrdersManualHandling']),
            parameterCalibration() {
                if (!this.date) {
                    this.$message.error('请选择时间');
                    return false
                }
                return true
            },
            getList(page = 1) {
                if(!this.parameterCalibration()) return;
                this.loading = true;
                this.currentPage = page;
                this.playerRechargeList({
                    userRandomId: this.userRandomId,
                    appType: this.appType,
                    channelCode: this.channelCode,
                    paymentWay: this.paymentWay,
                    status: this.status,
                    startTime: this.date[0],
                    endTime: this.date[1],
                    page: page
                }).then(res => {
                    this.playerRecharge = res;
                    this.loading = false;
                })
            },
            // 手工处理发放金豆
            updateStatus(row) {
                this.$confirm('确定发放金豆给玩家？', '提示', {
                    type: 'info'
                }).then(() => {
                    this.rechargeOrdersManualHandling({
                        orderNo: row.orderNo,
                        type: 2
                    }).then(() => {
                        this.$message.success('请求成功');
                        this.getList(this.currentPage)
                    })
                }).catch(() => {
                });
            },
            exportFunc() {
                if(!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/rechargeOrders/player/export',
                    info: [
                        {name: 'channelCode', value: this.channelCode},
                        {name: 'paymentWay', value: this.paymentWay},
                        {name: 'appType', value: this.appType},
                        {name: 'status', value: this.status},
                        {name: 'startTime', value: this.date[0]},
                        {name: 'endTime', value: this.date[1]},
                        {name: 'userRandomId', value: this.userRandomId},
                    ]
                });
            }
        }
    }
</script>
